import { ZAttrValue } from "../../types/dataTypes";
import { getScalarValue } from "./getScalarValue";

export const getStringValue = (
  aValue: ZAttrValue | null,
): string | undefined => {
  const scalar = getScalarValue(aValue);
  return typeof scalar === "string" ? scalar : undefined;
};
